import {
    createContext,
} from 'react';

export default createContext({
  pictureInPictureActive: false,
  togglePictureInPicture: () => {},
});
